import { Permission, Res } from 'core/api';
import * as SessionProvider from '../infrastructure/SessionProvider';
import { Toaster } from 'core/ui-next';

function showErrorIfSessionIsStarted(msg: string): void {
	// Hay muchos errores (permisos, módulos, etc.) que no tiene sentido mostrar si no
	// hay sesión iniciada, porque dependen del SessionDTO para poder calcularse con sentido
	if (SessionProvider.isSessionStarted())
		Toaster.error(msg);
}

export function always() {
	return true;
}

export function and(...args: (() => boolean)[]): () => boolean {
	return () => {
		return args.every(x => x());
	};
}

export function or(...args: (() => boolean)[]): () => boolean {
	return () => {
		return args.some(x => x());
	};
}


export function ensureStockModule(): boolean {
	if (SessionProvider.isStockModuleEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_STOCK_MODULE_IS_DISABLED());
	return false;
}

export function ensureCardProcessorModule(): boolean {
	if (SessionProvider.isCardProcessorModuleEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_CARD_PROCESSOR_MODULE_IS_DISABLED());
	return false;
}

export function ensureTicketBAIModule(): boolean {
	if (SessionProvider.isTicketBAIEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_TICKET_BAI_MODULE_IS_DISABLED());
	return false;
}

export function ensureTraceabilityModule(): boolean {
	if (SessionProvider.isTraceabilityEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_TRACEABILITY_MODULE_IS_DISABLED());
	return false;
}

export function ensureCashControlModule(): boolean {
	if (SessionProvider.isCashControlModuleEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_CASH_CONTROL_MODULE_IS_DISABLED());
	return false;
}

export function ensureTablePaymentModule(): boolean {
	if (SessionProvider.isTablePaymentModuleEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_TABLE_PAYMENT_MODULE_IS_DISABLED());
	return false;
}

export function ensureIsNotLite(): boolean {
	if (!SessionProvider.isLite())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_OPTION_NOT_AVAILABLE_IN_LITE());
	return false;
}

export function ensureKitchenDisplayModule(): boolean {
	if (SessionProvider.isKitchenDisplayModuleEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_KITCHEN_DISPLAY_MODULE_IS_DISABLED());
	return false;
}

export function ensureScaleSystemModule(): boolean {
	if (SessionProvider.isScaleSystemEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_SCALE_SYSTEM_MODULE_IS_DISABLED());
	return false;
}


export function ensurePriceListSchedulerModule(): boolean {
	if (SessionProvider.isPriceListSchedulerModuleEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_PRICE_LIST_SCHEDULER_MODULE_IS_DISABLED());
	return false;
}

export function ensureAttendanceModule(): boolean {
	if (SessionProvider.isAttendanceModuleEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_ATTENDANCE_MODULE_IS_DISABLED());
	return false;
}

export function ensureEmailingModule(): boolean {
	if (SessionProvider.isEmailingModuleEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_EMAILING_MODULE_IS_DISABLED());
	return false;
}

export function ensureSaleFormatModule(): boolean {
	if (SessionProvider.isSaleFormatModuleEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_SALE_FORMATS_IS_DISABLED());
	return false;
}

export function ensureAllowCashTransactions(): boolean {
	const allow = SessionProvider.getCurrent().AllowCashTransactions;
	if (!allow)
		showErrorIfSessionIsStarted(Res.Msg.MSG_CURRENT_POS_DOES_NOT_ALLOW_CASH_TRANSACTIONS());
	return allow;
}

export function ensureSlaveCanHandleCashOperations(): boolean {
	const masterHasCashControl = SessionProvider.getCurrent().MasterHasCashControl;
	if (masterHasCashControl) {
		showErrorIfSessionIsStarted(Res.Msg.MSG_INVALID_SLAVE_CASH_OPERATION());
		return false;
	}
	return true;
}

export function ensureSmartMenuModule(): boolean {
	if (SessionProvider.isSmartMenuEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_SMART_MENU_MODULE_IS_DISABLED());
	return false;
}

export function ensureDeliveryModule(): boolean {
	if (SessionProvider.isDeliveryEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_DELIVERY_MODULE_IS_DISABLED());
	return false;
}

export function ensureIsMaster(): boolean {
	if (!SessionProvider.isSlave())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_OPERATION_DENIED_ON_SLAVE_POS());
	return false;
}

export function ensureSizeAndColorModule(): boolean {
	if (SessionProvider.isSizeAndColorEnabled())
		return true;

	showErrorIfSessionIsStarted(Res.Msg.MSG_SIZE_AND_COLOR_MODULE_IS_DISABLED());
	return false;
}

export function ensure(permission: Permission): () => boolean {
	return function () {
		if (SessionProvider.hasPermission(permission))
			return true;

		showErrorIfSessionIsStarted(Res.Msg.MSG_PERMISSION_DENIED_FOR(Permission.toString(permission)));
		return false;
	};
}

